import React, { useState } from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";

const NmWorkflowHelpGuide = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        className="toggle-help-btn"
        onClick={() => setOpen(true)}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === "Enter" || e.key === " ") setOpen(true);
        }}
      >
        Page Help
        <img
          src={require("assets/images/formkit_help.svg")}
          alt=""
          className="help-icon-img"
        />
      </div>
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        direction="right"
        size={500}
        duration={400}
        overlayOpacity={0.5}
        overlayColor="#000"
        className="help-guide-drawer drawer-override"
      >
        <div className="drawer-content">
          <div className="drawer-header">
            <div className="header-title">
              <span className="emoji">📝</span>
              <span className="title">NM Workflow – Help Guide</span>
            </div>
            <button
              className="close-button"
              onClick={() => setOpen(false)}
              aria-label="Close help panel"
            >
              &times;
            </button>
          </div>
          <div className="drawer-body">
    <p>
      This page allows you to configure the fields and behavior of the Near Miss reporting form at the organization level.
    </p>
    <p>
      All changes made can be seen live in the <b>Preview - NM Reporting Form</b> located on the right side of the screen.
    </p>

    {/* Reporting Parameter */}
    <h5 className="section-title"><span className="emoji">📝</span> Reporting Parameter</h5>
    <hr />
    <p>Use this section to decide which fields should appear on the Near Miss reporting form.</p>
    <ul className="steps-list">
      <li><span className="step-number">1️⃣</span> Tick a checkbox to include a field.</li>
      <li><span className="step-number">2️⃣</span> Untick a checkbox to exclude it.</li>
    </ul>
    <div className="alert alert-success" style={{color:'black'}}>
      <strong>✅ Example:</strong> If you don't want to show <b>Hazard</b> in the NM reporting form, simply untick its checkbox.
    </div>
    <p>After making changes, click <b>Save</b> to apply them.</p>

    {/* PPC Parameter */}
    <h5 className="section-title"><span className="emoji">🏢</span> Plant / Project / Client Based Parameter</h5>
    <hr />
    <ul className="steps-list">
      <li><span className="step-number">1️⃣</span> Fields with grey checkboxes are pre-configured at the PPC level and cannot be modified from this page.</li>
      <li><span className="step-number">2️⃣</span> For Division/Department settings, you must choose only one configuration method:
        <ul>
          <li>• Division-based reporting</li>
          <li>• Department-based reporting</li>
        </ul>
      </li>
    </ul>
    <div className="alert alert-warning" style={{color:'black'}}>
      <strong>⚠️ Note:</strong> You cannot enable both options at the same time.
    </div>

    {/* System Defaults */}
    <h5 className="section-title"><span className="emoji">🔒</span> System Default Parameter</h5>
    <hr />
    <p>These are mandatory fields that are always included in the Near Miss reporting form and cannot be disabled.</p>

    {/* Evidence Upload */}
    <h5 className="section-title"><span className="emoji">📸</span> Evidence Upload Limit</h5>
    <hr />
    <p>Set the maximum number of evidence files (photos, videos, documents) that a user can upload with a Near Miss report.</p>

    {/* Investigation Steps */}
    <h5 className="section-title"><span className="emoji">📋</span> NM Investigation Steps</h5>
    <hr />
    <p>The investigation process for Near Miss reports is standardized into three fixed steps.</p>
    <div className="alert alert-warning" style={{color:'black'}}>
      <strong>⚠️ Note:</strong> These steps cannot be edited or customized.
    </div>
    <p>You can, however, configure related data collection options:</p>
    <ul className="steps-list">
      <li><span className="step-number">1️⃣</span> <strong>NM Documents:</strong> Enable users to upload relevant documentation during the investigation.</li>
      <li><span className="step-number">2️⃣</span> <strong>NM Costing:</strong> Allow users to input cost data related to the near miss. Cost fields are configurable via the Costing Module.</li>
    </ul>

    {/* NM Document Upload */}
    <h5 className="section-title"><span className="emoji">📄</span> Near Miss Document Upload</h5>
    <hr />
    <ul className="steps-list">
      <li><span className="step-number">1️⃣</span> Tick the checkbox to include NM document upload as part of the investigation process.</li>
      <li><span className="step-number">2️⃣</span> Untick if you don't want to allow document uploads in this section.</li>
    </ul>

    {/* NM Cost */}
    <h5 className="section-title"><span className="emoji">💰</span> Near Miss Cost</h5>
    <hr />
    <ul className="steps-list">
      <li><span className="step-number">1️⃣</span> Tick the checkbox to enable the NM costing section in the investigation form.</li>
      <li><span className="step-number">2️⃣</span> Untick to exclude it.</li>
      <li><span className="step-number">3️⃣</span> Costing fields are customizable via the Costing Module.</li>
    </ul>
  </div>
        </div>
      </Drawer>
    </>
  );
};

export default NmWorkflowHelpGuide;


